const NAMED_HEADQUARTERS_CODE = '180000';

export class Sidc {
    readonly underlying: string;

    constructor(sidc: string | Sidc) {
        if (sidc instanceof Sidc) {
            this.underlying = sidc.underlying;
        } else {
            if (sidc.length !== 20) {
                throw new Error(`SIDC must be 20 characters long, but got ${sidc.length}: ${sidc}`);
            }
            this.underlying = sidc;
        }
    }

    substring(start: number, end?: number): string {
        return this.underlying.substring(start, end);
    }

    withMainIconCodeReplacedBy(newMainIconCode: string): Sidc {
        if (newMainIconCode.length !== 6) {
            throw new Error(
                `New main icon code must be 6 characters long, but got ${newMainIconCode.length}: ${newMainIconCode}`,
            );
        }
        return new Sidc(this.substring(0, 10) + newMainIconCode + this.substring(16));
    }

    isNamedHeadquarters(): boolean {
        return this.substring(10, 16) === NAMED_HEADQUARTERS_CODE;
    }

    convertedToNamedHeadquarters(): Sidc {
        if (!this.isLandUnit()) {
            throw new Error(
                `Cannot convert to a named headquarters because this is not a land unit: \n${this}`,
            );
        }
        if (!this.hasNoMainIcon()) {
            throw new Error(
                `Cannot convert to a named headquarters because this already has a main icon: \n${this}`,
            );
        }
        return this.withMainIconCodeReplacedBy(NAMED_HEADQUARTERS_CODE);
    }

    hasNoMainIcon(): boolean {
        return this.substring(10, 16) === '000000';
    }

    isLandUnit(): boolean {
        return this.substring(4, 6) === '10';
    }
}
